export const isRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null;

export const asRecord = <T extends object = Record<string, unknown>>(value: unknown): Partial<T> =>
    typeof value === 'object' && value !== null ? (value as Partial<T>) : ({} as Partial<T>);

export const toNumber = (value: unknown, fallback = 0): number => (typeof value === 'number' ? value : fallback);

export const toString = (value: unknown, fallback = ''): string => (typeof value === 'string' ? value : fallback);

export const toBoolean = (value: unknown, fallback = false): boolean => (typeof value === 'boolean' ? value : fallback);

export const toNullableString = (value: unknown): string | null => (typeof value === 'string' ? value : null);

export const toBooleanLoose = (value: unknown, fallback = false): boolean => {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') {
        if (value.toLowerCase() === 'true') return true;
        if (value.toLowerCase() === 'false') return false;
    }
    return fallback;
};

export const mapRecordToBoolean = (value: unknown): Record<string, boolean> => {
    const record = asRecord(value);
    const result: Record<string, boolean> = {};
    for (const [key, entry] of Object.entries(record)) {
        result[key] = toBooleanLoose(entry);
    }
    return result;
};
